module.exports = __webpack_public_path__ + "static/media/20250225_092149.d7b06af1.webp";